import { Flex } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { List } from "@/molecules/List"

import type { ValueListProps } from "."

export const ValueList = <I,>(props: ValueListProps<I>) => {
  const defaultRender = (value: I) => (
    <div>{typeof value === "string" ? value : `${value}`}</div>
  )
  const { limit = 3, render = defaultRender, titleKey, items, ...rest } = props
  const { t } = useTranslation()

  const showMoreTitle =
    titleKey &&
    items.length > limit &&
    `+${t(titleKey, { count: items.length - limit })}`

  return (
    <Flex vertical>
      <List<I>
        items={items}
        limit={limit}
        render={render}
        showMoreTitle={showMoreTitle || undefined}
        {...rest}
      />
    </Flex>
  )
}
